export default () => ({
  online: true
})
